import { Form } from 'formik';
import FormSwitchButton from '../FormSwitchButton';

function MiscSettings() {
  const mcuDetectionDescription =
    'A forced-speaker-switch layout will be sent to Poly MCUs when this setting is enabled, otherwise the default VTC layout will be used.';

  const videoPrioritizedDescription = `A video-prioritized layout only displays video-enabled participants. If no video-enabled participants exist, then the video-muted participants will be displayed.`;

  return (
    <>
      <Form style={{ paddingTop: 10 }}>
        <FormSwitchButton
          name="enableMcuDetection"
          label="Enable MCU Detection"
          description={mcuDetectionDescription}
        />
      </Form>
      <hr />
      <Form style={{ paddingTop: 10 }}>
        <FormSwitchButton
          name="useVideoPrioritizedLayout"
          label="Use Video-Prioritized Layout"
          description={videoPrioritizedDescription}
        />
      </Form>
    </>
  );
}

export default MiscSettings;
